import { AppConfig } from 'models';

export const localConfig = {
  apiUrl: 'http://localhost:8080',
} as AppConfig;

export const prodConfig = {
  apiUrl: 'https://dogecrack-shepherd-prod-8mxaw.ondigitalocean.app',
} as AppConfig;
